module.exports = __webpack_public_path__ + "ce01c848b5a09253c376b0cbfdc47f4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000LH7.png
// module id = 1595
// module chunks = 0